import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import path from 'path';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';

export default Vue.component('dynamic-media', {
  template: require('./template.html'),
  name: 'dynamic-media',
  mixins: [guid, uploader],
  computed: {
    ...mapGetters(['currentSite', 'activeSiteType']),
    fileName() {
      const file = this.activeItem[this.type];
      return file ? path.basename(file) : 'No File Uploaded';
    },
  },
  components: {
    uploadProgress,
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'accepted',
  ],
  data() {
    return {
      bucketPath: null,
      prefix: null,
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      // for s3 assets
      this.bucketPath = `_droplet-assets/${this.activeSiteType}/${this.type}/`;
      this.prefix = `drz_${this.activeSiteType}_${Date.now()}_`;
    },
    openUpload() {
      this.$refs.uploadFile.click();
    },
    async uploadMedia(e) {
      this.$validator.validateAll().then(async (result) => {
        // run only if file types and dimensions are correct
        if (result) {
          let newFile = [...e.target.files];
          if (newFile.length > 0) {
            newFile = newFile[0];
            // clean up the file name for s3
            let fileName = path.basename(newFile.name);
            fileName = `${this.prefix}${_.trim(fileName)}`;
            fileName = _.replace(fileName, /\s+/g, '_');

            try {
              // send off to our s3 upload mixin
              const filePath = `/${this.bucketPath}${fileName}`;
              await this.uploadFile({
                file: `${this._sitePath}${filePath}`,
                body: newFile,
              });
              this.$store.dispatch('setDropletVal', {
                drp: this.activeItem,
                key: this.type,
                val: filePath,
              });
            } catch (err) {
              if (!err.message.match(/aborted/gi)) {
                this.$log.error(err);
                await this._reportError({
                  error: err,
                  fn: 'uploadMedia',
                });
              }
            }
          }
          // reset value to null so we can get the "change" event to run
          // in any case. Even when the user selects the same file
          e.target.value = null;
        }
      });
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/media/index.js